import { render, staticRenderFns } from "./FormTemplateParagraph.vue?vue&type=template&id=3b2caa73&scoped=true&"
import script from "./FormTemplateParagraph.vue?vue&type=script&lang=js&"
export * from "./FormTemplateParagraph.vue?vue&type=script&lang=js&"
import style0 from "./FormTemplateParagraph.vue?vue&type=style&index=0&id=3b2caa73&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b2caa73",
  null
  
)

export default component.exports